import { findIndex, cloneDeep } from "lodash"
//import sendxAPI from '../../../xAPI'

const templateState = {
  id: -1,
  type: null,
  solutions: [{
    id: null,
    type: null
  },{
    id: null,
    type: null
  },{
    id: null,
    type: null
  },{
    id: null,
    type: null
  },{
    id: null,
    type: null
  },{
    id: null,
    type: null
  }],
  numberOfSolutions: 0,
  description: "",
};

export function IceBucketReducer(state = { iceBuckets: [] }, action) {
  let currentIceBucket;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
      return state;
  }

  if (action.type !== "CREATE_ICE_BUCKET" && !action.type.includes("@redux")) {
      if(action.payload.hasOwnProperty("id")){
        if(state.protocolSection.scene.apparatus.hasOwnProperty("iceBuckets")){
          currentIceBucket = state.protocolSection.scene.apparatus.iceBuckets[findIndex(state.protocolSection.scene.apparatus.iceBuckets, { id: action.payload.id })]
        }
      }
  }

  switch (action.type) {

        case 'CREATE_ICE_BUCKET':

          //Create new obj from template state
          let newObj = { ...templateState, ...action.payload.props }

          if(protocolSection.scene.apparatus.hasOwnProperty("iceBuckets")){
            protocolSection.scene.apparatus.iceBuckets = [ ...protocolSection.scene.apparatus.iceBuckets, newObj ]
          } else {
            protocolSection.scene.apparatus.iceBuckets = [newObj]
          }

          return { ...state, ...{
            protocolSection: protocolSection
          } }


        case "ADD_TUBE_TO_ICE_BUCKET":
          //Payload = {id, type}

          let addSolutions = cloneDeep(currentIceBucket.solutions);
          let availableSlot = -1;

          for(var i = 0; i < currentIceBucket.solutions.length; i++){
            if(currentIceBucket.solutions[i].type == null){
              availableSlot = i;
              break;
            }
          }

          if(availableSlot !== -1){
            addSolutions[availableSlot].type = action.payload.type;
            addSolutions[availableSlot].id = action.payload.solutionId;
            currentIceBucket.numberOfSolutions++
          }

          currentIceBucket.solutions = addSolutions;
          protocolSection.scene.apparatus.iceBuckets[findIndex(protocolSection.scene.apparatus.iceBuckets, { id: action.payload.id })] = currentIceBucket

          return { ...state, ...{
            protocolSection: protocolSection
          } }

        case "REMOVE_TUBE_FROM_ICE_BUCKET":
          //Payload = {id, type}
          let removeSolutions = cloneDeep(currentIceBucket.solutions);
          let index = findIndex(currentIceBucket.solutions, {id: action.payload.solutionId})

          if(index !== null && index !== -1 && removeSolutions.hasOwnProperty(index) && removeSolutions[index].type !== null){
            removeSolutions[index].type = null;
            removeSolutions[index].id = null;
            currentIceBucket.numberOfSolutions--
          }

          currentIceBucket.solutions = removeSolutions;
          protocolSection.scene.apparatus.iceBuckets[findIndex(protocolSection.scene.apparatus.iceBuckets, { id: action.payload.id })] = currentIceBucket

          return { ...state, ...{
            protocolSection: protocolSection
          } }

        case "UNDO":
            //Payload = {lastState}

            if (action.payload.lastState !== null) {

              protocolSection.scene.apparatus.iceBuckets = action.payload.lastState.scene.apparatus.iceBuckets

              return { ...state, ...{
                protocolSection: protocolSection
              } }

            } else {
              return state;
            }

        default:
            return state;
    }
}
